angular.module('impactx.purchaserequest').controller('PurchaseRequestListCtrl', [
    '$rootScope',
    'selectedListItems',
    '$redirect',
    '$mdDialog',
    'dataGen',
    'basketTemplateMenu',
    '$context',
    'ToastService',
    'OpenGovernmentDataService',
    'TranslationService',
    'CancellationService',
    'TemplateNameService',
    'ConfirmationService',
    '$route',
    'EformsHandoffService',
    function($rootScope, selectedListItems, $redirect, $mdDialog, dataGen, basketTemplateMenu, $context, ToastService, OpenGovernmentDataService, TranslationService, CancellationService, TemplateNameService, ConfirmationService, $route, EformsHandoffService) {
        var ctrl = this;
        this.checkState = function(event, trns) {
            var stateOk = false;
            var multiOk = true;
            var selected = selectedListItems.getSelectedItems();
            if(selected.length > 0) {
                for(var i = 0; i < selected.length; i++) {
                    if(selected[i].stateAllowedForDNH.value) {
                        stateOk = true;
                    }
                    if (selected.length > 1 && (!selected[i].multiplePOHForDNHAllowed || !selected[i].multiplePOHForDNHAllowed.value)) {
                        multiOk = false;
                    }
                }
            }
            if(stateOk && multiOk) {
                $redirect.redirectTo(null, "/deliverynote");
            }
            else if (!stateOk){
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .textContent(trns.wrongState)
                        .ariaLabel('Alert Dialog')
                        .ok('Ok')
                );
            }
            else {
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .textContent(trns.multiplePOHError)
                        .ariaLabel('Alert Dialog')
                        .ok('Ok')
                );
            }
        };

        this.cancelItems = function(event) {
            CancellationService.cancelItems(event, selectedListItems.getSelectedItems());
        };

        this.cancelAll = function(event) {
            CancellationService.cancelAll(event, selectedListItems.getSelectedItems());
        };

        this.createBasketTemplate = function() {
            var selectedItems = selectedListItems.getSelectedItems();
                TemplateNameService.showTemplateName(getSelectionList(), '/basket/template/beforecreatefromorder', event).then(function(answer){
                if(answer)
                {
                    dataGen.postAsForm({}, {items: getSelectionList(), name: answer}, '/basket/template/createfromorder').then(function()
                    {
                        selectedListItems.unselectAll(selectedItems);
                        $rootScope.$broadcast('list:resetPageSelection');
                        basketTemplateMenu.refreshAllTemplates();
                    });
                }
            });
        }

        this.addToCurrentBasket = function(ev) {
            $mdDialog.show({
                controller: "AddToBasketOrderController",
                controllerAs: 'ctrl',
                templateUrl: 'modules/basket/templates/add-to-basket-config.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    multipleSelection: getSelectionList().length > 1
                }
            }).then(function (answer) {
                if (answer) {
                    var scope = {};
                    var selectedItems = selectedListItems.getSelectedItems();
                    dataGen.postAsForm(scope, {items: getSelectionList(), config: answer}, '/purchaserequest/addtobasket').then(function() {
                        $context.refreshBasket({}, dataGen, $context);
                        ToastService.openStandardToast(scope.trns.addToCurrentBasketSuccess);
                        selectedListItems.unselectAll(selectedItems);
                        $rootScope.$broadcast('list:resetPageSelection');
                    }, function () {
                        $context.refreshBasket({}, dataGen, $context);
                    });
                }
            });
        };

        var getSelectionList = function() {
            var selectedItems = selectedListItems.getSelectedItems(),
            selectionList = [];
            angular.forEach(selectedItems, function(row){
                if(row.isOrder.value && row.pohId > 0){
                    selectionList.push({pohId: row.pohId});
                }
                else if(row.prsId) {
                    selectionList.push({prsId: row.prsId})
                }
                else if(row.prhId > 0) {
                    selectionList.push({prhId: row.prhId});
                }
            });
            return selectionList;
        };

        this.showDeliveryNoteButton = function() {
            var selected = selectedListItems.getSelectedItems();
            for(var i = 0; i < selected.length; i++) {
                if(selected[i].isOrder.value && !selected[i].isCancel.value) {
                    return true;
                }
            }
            return false;
        };

        this.showBasketButton = function()
        {
            var selected = selectedListItems.getSelectedItems();
            if (selected.length > 0) {
                for (var i = 0; i < selected.length; i++) {
                    if (selected[i].isCancel.value) {
                        return false;
                    }
                }
                return true;
            }
            else {
                return false;
            }
        };

        this.showCancelButton = function() {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCancel.value && !selectedListItems.getFirstSelectedItem().isCancel.value;
        };

        this.showPartialCancelButton = function() {
            var item = selectedListItems.getFirstSelectedItem();
            return ctrl.showCancelButton() && (!item.canPartialCancel || item.canPartialCancel.value === true);
        };

        this.getDetailLink = function() {
            if(selectedListItems.getFirstSelectedItem()) {
                return selectedListItems.getFirstSelectedItem().isOrder.value ? ("purchaseorderdetail/" + selectedListItems.getFirstSelectedItem().pohId) :
                    ("purchaserequestdetail/" + selectedListItems.getFirstSelectedItem().prhId + "/" + selectedListItems.getFirstSelectedItem().prsId)
            }
            else {
                return null;
            }
        };
        this.getDeliveryComplaintLink = function() {
            if(selectedListItems.getFirstSelectedItem()) {
                return "deliverycomplaint/0/0/" + selectedListItems.getFirstSelectedItem().pohId;
            }
            else {
                return false;
            }
        };

        this.canComplain = function() {
            if(selectedListItems.getFirstSelectedItem()) {
                return selectedListItems.isMultiSelection() && selectedListItems.getFirstSelectedItem().canComplain.value && !selectedListItems.getFirstSelectedItem().isCancel.value;
            }
            else {
                return false;
            }
        };

        this.canReportOGD = function () {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReportOGD.value && !selectedListItems.getFirstSelectedItem().isCancel.value;
        };

        /*
         * "Meine Bestellungen" mixes requests and orders: the POH.Id only exists on rows that show an
         * order. The backend already sets the flag to false for request rows -- the row check here is
         * the second belt, not a replacement. Cancellation rows are excluded like for reportOGD.
         * Mirrors canAnnounceEForms() of the Angular PurchaseRequestListComponent.
         */
        this.canAnnounceEForms = function () {
            var item = selectedListItems.getFirstSelectedItem();
            return selectedListItems.isSingleSelection() && item && item.isOrder && item.isOrder.value
                && item.pohId > 0
                && item.canAnnounceEForms && item.canAnnounceEForms.value === true
                && !(item.isCancel && item.isCancel.value);
        };

        /*
         * Jumps off to the eForms handoff page for the selected order. Without a selected order row
         * nothing happens; a blocked popup is reported by the service instead of being swallowed.
         */
        this.announceEForms = function () {
            var item = selectedListItems.getFirstSelectedItem();
            if (!item || !item.isOrder || !item.isOrder.value || item.pohId <= 0) {
                return;
            }

            EformsHandoffService.openHandoff(item.pohId);
        };

        this.canJumpToCancelRequest = function () {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().crhId > 0;
        };

        this.getCancelRequestLink = function () {
            var item = selectedListItems.getFirstSelectedItem();
            var crhId = item ? item.crhId : '';
            
            return "crhdetails/" + crhId;
        };

        this.reportOpenGovernmentData = function (event) {
            var pohId = selectedListItems.getFirstSelectedItem().pohId;
            dataGen.getData({}, {pohId: pohId}, "/opengovernmentdata/purchaseorder/check").then(function (rsp) {
                if(rsp && rsp.data)
                {
                    if(!rsp.data.noInfo)
                    {
                        $mdDialog.show({
                            controller: 'OpenGovernmentDataOverdueDialogCtrl',
                            controllerAs: 'ctrl',
                            locals: {
                                pohId: pohId
                            },
                            templateUrl: 'modules/opengovernmentdata/templates/opengovernmentoverdue.dialog.html',
                            parent: angular.element(document.body),
                            bindToController: true,
                            targetEvent: event,
                            data: rsp.data,
                            trns: rsp.trns
                        }).then(function () {
                            OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                        });
                    }
                    else
                    {
                        OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                    }
                }
            })
        };

        this.canRejectAwardDecision = function () {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canRejectAwardDecision.value;
        };

        this.canModifyOrder = function () {
            var item = selectedListItems.getFirstSelectedItem();
            return selectedListItems.isSingleSelection() && item && item.isOrder.value && item.canModifyOrder && item.canModifyOrder.value === true;
        };

        this.modifyOrder = function () {
            return dataGen.postAsForm({}, {pohId: selectedListItems.getFirstSelectedItem().pohId}, '/purchaseorder/loadintobasket').then(function (result) {
                $context.refreshBasket({}, dataGen, $context);
                $redirect.redirectTo(null, '/basket/' + result.data.basketId);
            });
        };

        this.rejectAwardDecisionDialog = function (event, trns) {
            ConfirmationService.showConfirmationDialog(ctrl.rejectAwardDecision, event, TranslationService.get("warning"),
                TranslationService.get("ok"), TranslationService.get("abort"), trns.rejectAwardDecisionQuestion, trns);
        };

        this.rejectAwardDecision = function (event, trns) {
            var selectedItems = selectedListItems.getSelectedItems();
            dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedItem().prsId}, "/awarddecision/reject").then(function () {
                ToastService.openStandardToast(trns.rejectAwardDecisionSuccessfully);
                $rootScope.$broadcast('list:resetPageSelection');
                selectedListItems.unselectAll(selectedItems);
                $route.reload();
            });
        };

        this.canRelease = function () {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canRelease.value;
        };

        this.releaseDialog = function (event, trns) {
            var elem = selectedListItems.getFirstSelectedItem();
            ConfirmationService.showConfirmationDialog(ctrl.release, event, trns.release,
                trns.release, TranslationService.get("abort"), elem.releaseQuestion.value, trns);
        };

        this.release = function (event, trns) {
            var selectedItems = selectedListItems.getSelectedItems();
            dataGen.postAsForm({}, {prsId: selectedListItems.getFirstSelectedItem().prsId}, "/standstillinfo/release").then(function () {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $rootScope.$broadcast('list:resetPageSelection');
                selectedListItems.unselectAll(selectedItems);
            });
        };

        var buttonDefinition = [
            {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'Status'},
            {label: "cancelRequest", linkFunction: ctrl.getCancelRequestLink, type:'link', condition: ctrl.canJumpToCancelRequest, process: 'Status'},
            {label: "newComplaint", linkFunction: ctrl.getDeliveryComplaintLink, type:'link', condition:  ctrl.canComplain, process: 'ViewDeliveryComplaint'},
            {label: "createDelNote", action: ctrl.checkState, condition:  ctrl.showDeliveryNoteButton, process: 'EditDeliveryNote'},
            {label: "cancel", action: ctrl.cancelItems, condition:  ctrl.showPartialCancelButton, process: 'Status'},
            {label: "cancelAll", action: ctrl.cancelAll, condition:  ctrl.showCancelButton, process: 'Status'},
            {label: "createTemplate", action: ctrl.createBasketTemplate, condition: ctrl.showBasketButton, process: 'AddTemplateToBasket'},
            {label: "addToBasket", action: ctrl.addToCurrentBasket, condition: ctrl.showBasketButton, process: 'AddTemplateToBasket'},
            {label: "reportOGD", action: ctrl.reportOpenGovernmentData, condition: ctrl.canReportOGD, process: 'ReportOGDSubsequently'},
            // no process: the buyer of the order may announce it without holding ReportOGDSubsequently
            {label: "announceEForms", action: ctrl.announceEForms, condition: ctrl.canAnnounceEForms},
            {label: "rejectAwardDecision", action: ctrl.rejectAwardDecisionDialog, condition: ctrl.canRejectAwardDecision, process: 'AwardDecisionReject'},
            {label: "releaseButton", action: ctrl.releaseDialog, condition: ctrl.canRelease, process: 'StandstillInfoOwn'},
            {label: "modifyOrder", action: ctrl.modifyOrder, condition: ctrl.canModifyOrder, process: 'AllowBuyerOrderChange'}
        ];

        function getItemExpansionEntryPoint(row) {
            return row.pohId ? '/purchaserequest/pohoverview' : '/purchaserequest/prsoverview';
        }

        function getItemExpansionParamsFunction(row) {
            if (row.pohId) {
                return {pohId: row.pohId};
            }
            return {prsId: row.prsId};
        }

        function getItemExpansionTemplate(row) {
            return row.pohId ? 'modules/status/purchaserequest/templates/purchaserequest-itemexpansion-poh.html' :
                'modules/status/purchaserequest/templates/purchaserequest-itemexpansion-prs.html';
        }

        this.meta = {
            rowTemplate: 'modules/status/purchaserequest/templates/purchaserequestlist.row.tmpl.html',
            isSelectAble: true,
            endpoint: '/purchaserequest/list',
            ctrl: this,
            id: "purchaserequest",
            buttonDefinition: buttonDefinition,
            itemExpansion: {
                entryPointFunction: getItemExpansionEntryPoint,
                paramsFunction: getItemExpansionParamsFunction,
                templateUrlFunction: getItemExpansionTemplate
            }
        };
        this.getMeta = function() {
            return this.meta;
        };
    }
]);
